<template>
  <div class="authLoader">
    <div class="loaderContent">
      <div class="logo">
        <img src="../../../../assets/images/pos-logo.png" max-width="100" />
      </div>
      <div class="loaderWrapper">
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
export default {
  name: "AuthLoader",
  components: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.authLoader {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .loaderContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
        img {
            // height: 80px;
            width: 500px;
        }
    }
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(50, 210, 141, 0.2);
  border-right: 1.1em solid rgba(50, 210, 141, 0.2);
  border-bottom: 1.1em solid rgba(50, 210, 141, 0.2);
  border-left: 1.1em solid #32d28d;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
